<!--/**
 * Componente Vue para visualizar un formulario con la informacion que le sea otorgada, esta informacion puede ser un JSON con datos,
 * un simple Array o un String (url) con el recurso a consumir.
 * @version 1.0.0
 * @author Santiago Urrego Giraldo.
 * @since 2017-04-06
 * @param items JSON con los nombres de los campos, label y datos adicionales que se va a mostrar en el formulario
 * Ejemplo:
 * [
 *     {
 *         name: 'first_name',              # name String Nombre del campo que viene en el recurso.
 *         label: 'Nombres',                # label String Nombre del campo para la cabecera.
 *         placeholder: 'ingrese nombre',   # placeholder String texto del campo cuando esta vacio.
 *         maxlength: '30',                 # maxlength int cantidad de caracteres permitidos por el campo.
 *         type: 'text',                    # type String tipo de contenido del campo.
 *         type: 'textarea',                # si el type es textarea se utilizara el control de tipo textarea.
 *              cols:'',                    # int que define la cantidad de columnas que tendra el textarea
 *              rows:'',                    # int que define la cantidad de filas que tendra el textarea
 *         type: 'select',                  # si el type es select se utilizara el control de tipo select.
 *              option:'',                  # string opcion que se visualizara en el select
 *              option.value                # valor de la opcion 
 *              option.text                 # texto de la opcion
 *      }
 * ]
 * Dependiendo el tipo de dato se mostrara el componente respectivo de cada campo al cual se le enviara el objeto actual del ciclo que se recorre para imprimir el formulario con los datos del campo especificamente
 * @param resource String con la url de recurso a consumir.
 * @param updateData Boolean permite mostrar el boton atras y el boton actualizar.
 * @param isLoading Boolean permite ocultar el boton guardar mientras responde el servicio.
 */-->
<template>
    <div method="post" action="" class="form-horizontal" role="form">
        <div class="form-group">
            <div v-for="item, key in items" v-show="typeof(item.visible)==='undefined' || item.visible">
                <emt-input v-if="item.type==='text' || item.type==='number' || item.type==='password' || item.type==='file'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-input>
                <emt-radio v-if="item.type==='radio'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-radio>
                <emt-select v-if="item.type==='select'" v-bind:item="item" v-on:change="check(item)" v-bind:className="'col-md-4'"></emt-select>
                <emt-checkbox v-if="item.type==='checkbox'" v-bind:item="item" v-bind:className="'col-md-1'"></emt-checkbox>
                <emt-textarea v-if="item.type==='textarea'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-textarea>
                <datepicker  v-if="item.type==='date'" language="es" v-on:input="updateDate" :name="item.name" :inputClass="item.class" :wrapperClass="item.divclass" :placeholder="item.placeholder" format="yyyy-MM-dd"></datepicker>
                <div v-if="(key + 1) % 3 === 0" class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div v-if="updateData">
                <div class="col-md-4"><router-link v-bind:to="'/ChangePassword/'+ this.$route.params.id ">Restablecer contraseña</router-link></div>
                <div class="clearfix"></div>
            </div>
            <br>
            <div class="col-md-12 text-center">
                <div v-if="updateData">
                    <input type="button" class="btn btn-info" value="Atrás" name="Atrás" v-on:click="behind">
                    <input v-if="!isLoading" type="button" class="btn btn-success" value="Actualizar" name="Actualizar" v-on:click="update">
                    <span v-else>Cargando...</span>
                </div>
                <div v-else-if="typeactivity">
                    <input type="button" class="btn btn-info" value="Atrás" name="Atrás" v-on:click="behind">
                    <input v-if="!isLoading" type="button" class="btn btn-success" value="Cambiar contraseña" name="Cambiar contraseña" v-on:click="updatePassword">
                    <span v-else>Cargando...</span>
                </div>
                <div v-else>
                    <input v-if="!isLoading" type="button" class="btn btn-success" value="Guardar" name="Guardar" v-on:click="register">
                    <span v-else>Cargando...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Config from '@/config'
import Datepicker from 'vuejs-datepicker'
import router from '@/router'
import EmtInput from '@/components/input-components/emt-input'
import EmtCheckbox from '@/components/input-components/emt-checkbox'
import EmtRadio from '@/components/input-components/emt-radio'
import EmtSelect from '@/components/input-components/emt-select'
import EmtTextarea from '@/components/input-components/emt-textarea'
import swal from 'sweetalert2'
import { Arrays } from '@/helpers'
export default {
    name: 'emt-form-register-user',
    data: function () {
        return {
            data: {
                form_values: {},
                form_perfil: {},
                errors: []
            },
            isLoading: false
        }
    },
    props: {
        resource: Array,
        items: Array,
        updateData: Boolean,
        typeactivity: String
    },
    methods: {
        /**
         * metodo que permite recorrer el formulario y almacenar sus valores
         */
        getFormValuesPassword: function () {
            var self = this
            self.data.form_values = {}
            for (var i = 0; i < self.items.length; i++) {
                var value = null
                if (typeof self.items[i].value === 'string') {
                    value = self.items[i].value != null ? self.items[i].value.trim() : null
                } else {
                    value = self.items[i].value
                }
                self.data.form_values[self.items[i].name] = value
            }
            return self.data.form_values
        },
        getFormValues: function () {
            var idgroup = document.getElementsByName('group')[0].value
            var self = this
            self.data.form_values = {}
            for (var i = 0; i < self.items.length; i++) {
                var value = null
                if (self.items[i].name === 'group') {
                    self.items[i].value = idgroup
                }
                if (typeof self.items[i].value === 'string') {
                    value = self.items[i].value != null ? self.items[i].value.trim() : null
                } else {
                    value = self.items[i].value
                }
                self.data.form_values[self.items[i].name] = value
            }
            return self.data.form_values
        },
        /**
         * metodo que permite limpiar los formularios despues de realizar alguna acción
         */
        clearFormValues: function () {
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].type === 'checkbox' || this.items[i].type === 'radio') {
                    this.items[i].value = false
                } else if (this.items[i].type === 'select') {
                    this.items[i].selectoptions = 0
                    this.items[i].value = ''
                } else {
                    this.items[i].value = null
                }
            }
            for (i in this.items) {
                this.items[i].errors = []
            }
            return null
        },
        /**
         * metodo que permite el registro de información
         */
        register: function (table) {
            var self = this
            var values = self.getFormValues()
            self.isLoading = true
            self.$http.post(Config.api + self.resource[0].resourceUser, values).then(function (response) {
                swal({
                    title: 'Se creó el registro exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                })
                self.isLoading = false
                self.clearFormValues()
                self.$emit('register')
            }, function (response) {
                self.data.errors = response.body
                self.isLoading = false
                var prop = null
                for (var i in self.items) {
                    self.items[i].errors = []
                }
                for (i in self.items) {
                    for (prop in self.data.errors) {
                        if (self.items[i].name === prop) {
                            if (prop === 'unit' || prop === 'group') {
                                self.items[i].errors.push(response.body[prop])
                            } else {
                                self.items[i].errors = response.body[prop]
                            }
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    swal({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                }
            })
        },
        updateDate: function (value) {
            for (var item in this.items) {
                value = value.toISOString().substring(0, 10)
                this.items[item].value = value
            }
        },
        update: function () {
            var self = this
            var values = self.getFormValues()
            self.isLoading = true
            self.$http.put(Config.api + self.resource[0].resourceUser + this.$route.params.id + '/', values).then(function (response) {
                self.isLoading = false
                swal({
                    title: 'Se realizó la actualización exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                })
                self.clearFormValues()
                router.go(-1)
            }, function (response) {
                self.data.errors = response.body
                self.isLoading = false
                var prop = null
                for (var i in self.items) {
                    self.items[i].errors = []
                }
                for (i in self.items) {
                    for (prop in self.data.errors) {
                        if (self.items[i].name === prop) {
                            self.items[i].errors.push(self.data.errors[prop])
                        }
                    }
                }
            })
        },
        updatePassword: function () {
            var self = this
            var values = self.getFormValuesPassword()
            values['id'] = this.$route.params.id
            self.isLoading = true
            self.$http.post(Config.change_password, values).then(function (response) {
                swal({
                    title: 'Se realizó el cambio de contraseña exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                })
                router.push('/User')
                self.isLoading = false
            }, function (response) {
                self.data.errors = response.body
                self.isLoading = false
                var prop = null
                for (var i in self.items) {
                    self.items[i].errors = []
                }
                for (i in self.items) {
                    for (prop in self.data.errors) {
                        if (self.items[i].name === prop) {
                            self.items[i].errors = response.body[prop]
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    swal({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                }
            })
        },
        behind: function () {
            router.go(-1)
        },
        check: function (item) {
            if (item.name === 'group') {
                var self = this
                var text = Arrays.getItemBy(item.select_options, 'value', parseInt(item.value)).text
                if (text === 'Consulta filial') {
                    Arrays.getItemBy(self.items, 'name', 'company').visible = true
                    Arrays.getItemBy(self.items, 'name', 'unit').visible = false
                } else {
                    Arrays.getItemBy(self.items, 'name', 'company').visible = false
                    Arrays.getItemBy(self.items, 'name', 'unit').visible = true
                }
            }
        }
    },
    components: {
        'emt-input': EmtInput,
        'emt-checkbox': EmtCheckbox,
        'emt-radio': EmtRadio,
        'emt-select': EmtSelect,
        'emt-textarea': EmtTextarea,
        'datepicker': Datepicker
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-register-user.vue?f758dbd8